import { NotificationsOutlined, VideocamOutlined } from '@mui/icons-material';
import { AiOutlineCalculator } from 'react-icons/ai';
import { MdOutlineAssignment } from 'react-icons/md';
import useSurvey from 'store/survey/useSurvey';
import usePatient from 'store/patient/usePatient';
import useStudent from 'store/student/useStudent';
import useNotification from 'hooks/useNotification';
import {
  Box,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
} from '@mui/material';
import PeopleAltOutlinedIcon from '@mui/icons-material/PeopleAltOutlined';

const Header = () => {
  const { student_uuid } = useStudent();
  const { patientInfo } = usePatient();
  const { onRequired } = useNotification();
  const { onUpdateSurveyType } = useSurvey();

  const onClickListItem = (label: string) => {
    if (label === 'Instructor-only') {
      const url = `${window.location.origin}/#/professorAuth`;
      window.open(url, '_blank', 'noopener,noreferrer');
      return;
    }

    if (label === 'Notice') {
      window.open(
        'https://www.smartenr.com/enrnotice',
        '_blank',
        'noopener,noreferrer'
      );
      return;
    }

    if (!student_uuid) return onRequired('REQUIRED.STUDENT');
    if (!patientInfo) return onRequired('REQUIRED.PATIENT');
    onUpdateSurveyType(label);
  };

  const menu = [
    {
      icon: <PeopleAltOutlinedIcon />,
      label: 'Instructor-only',
      width: '120px',
    },
    {
      icon: <AiOutlineCalculator />,
      label: 'Drug calculator',
      width: '120px',
    },
    {
      icon: <VideocamOutlined />,
      label: 'Video Upload',
      width: '160px',
    },
    {
      icon: <NotificationsOutlined />,
      label: 'Notice',
      width: '120px',
    },
  ];

  return (
    <Box
      sx={{
        display: 'flex',
        direction: 'row',
        width: '700px',
        alignItems: 'center',
      }}
    >
      {menu.map(({ icon, label, width }) => (
        <ListItem
          key={label}
          disablePadding
          ref={null}
          sx={{ whiteSpace: 'pre-wrap' }}
        >
          <ListItemButton
            onClick={() => onClickListItem(label)}
            sx={{
              display: 'block',
              width:
                width ??
                (label === '핵심간호술기영상 저장' ? '150px' : '100px'),
              height: '40px',
              p: 0,
              alignItems: 'center',
              borderRadius: '8px',
              m: '1px',
            }}
          >
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
              <ListItemIcon
                className="HeadName"
                sx={{
                  my: '6px',
                  justifyContent: 'center',
                }}
              >
                {icon}
              </ListItemIcon>
              <ListItemText
                primaryTypographyProps={{
                  fontSize: '12px',
                  textAlign: 'center',
                  width: '100px',
                }}
                primary={label}
              />
            </Box>
          </ListItemButton>
        </ListItem>
      ))}
    </Box>
  );
};

export default Header;
